export enum BedBoardSettingsStatus {
  Occupied = 'Occupied',
  Free = 'Free',
  HoldUnpaid = 'Hold-Unpaid',
  HoldPaid = 'Hold-Paid',
}

export interface BedBoardSettings {
  _id?: string;
  action_code_id: number;
  status_code_id: number;
  action_long_desc: string;	
  action_fac_id: number;
  action_action_type: string;
  status_short_desc: string;
  status_long_desc: string;
  status_action_type: string;
  usage_count: number;
  bed_status: BedBoardSettingsStatus;
}

export interface BedBoardSettingsColumnConfig {
  label: string;
  key: string;
}